module.exports = __webpack_public_path__ + "img/skull_intelligence.6e0198fa.png";